let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hn2iP")).then(() => parcelRequire('49aS0'));